// project imports
import Utils from "./utils"
import * as keys from "./keys"

import AuthStore from "modules/login/store/AuthStore";
import FamilyMemberTypeEnum from 'modules/family-details-form/FamilymemberTypeEnum'
import { toJS } from "mobx";
import moment from "moment"

const FormObserver = (formRef, props) => {

  formRef.$("payment-frequency").observe({
    key: "value",
    call: ({ field }) => {
      let premium = formRef.$("premium-amt").value
      let frequency = field.value.id
      let data = {
        premium: premium,
        frequency: frequency,
      }
      Utils.updateBi(
        keys.FREQUENCY,
        data,
        props.data.product_id,
        formRef,
        props
      )
    },
  })

  formRef.$("source-of-purchase-price").observe({
    key: "value",
    call: ({ field }) => {

      const sppValue = Number(field.value.id)

      if(sppValue === 4){
        // pran-number
        formRef.$("pran-number").set("extra", {
          ...formRef.$("pran-number").extra,
          visible: true,
        });
      }else{
        formRef.$("pran-number").set("value" , "")
        formRef.$("pran-number").set("extra", {
          ...formRef.$("pran-number").extra,
          visible: false,
        });
      }
      let requestData = {
        sourceOfPP: sppValue,
        pranNo : sppValue === 4 ? formRef.$("pran-number").value : ""
      }
      Utils.updateBi(
        keys.SOURCE_OF_PURCHASE_PRICE,
        requestData,
        props.data.product_id,
        formRef,
        props
      );
    },
  })

  formRef.$("annuity-benefit").observe({
    key: "value",
    call: ({ field,form }) => {

       let defermentPeriodValue = form.$("deferment-period").value.id;
        let annuityBenefitValue = field.value.id

      Utils.updateBi(
        keys.ANNUITY_BENEFIT,
        {defermentPeriodValue,annuityBenefitValue},
        props.data.product_id,
        formRef,
        props
      );
    },
  })

  formRef.$("life-status").observe({
    key: "value",
    call: ({ field,form }) => {
      let annuityOptionList= []

      if(field.value.id === '3'){

        // ! // ! disabling Name of the Secondary Annuitant, DOB of the Secondary Annuitant, Gender of the Secondary Annuitant

        form.$("secondary-annuitant-name").set("disabled",true)
        form.$("secondary-annuitant-date-of-birth").set("disabled",true);
        form.$("secondary-annuitant-gender").set("disabled",true);

        //! for setting the values of the default
        form.$('secondary-annuitant-name').set('value', '');
        form.$("secondary-annuitant-date-of-birth").set("value","");
        form.$("secondary-annuitant-gender").set("value","");

        // Immediate annuity
        if(Number(form.$("annuity-benefit").value.id) === 1) {
          annuityOptionList = [
            { label: "Life Annuity", id: "25" },
            {
            label: "Life Annuity with Return of Purchase Price on Death",
            id: "26",
            },
            {
            label:
                "Life Annuity with Return of Balance Purchase Price on Death",
            id: "27",
            },
            {
            label:
                "Life Annuity with Return of Purchase Price on Critical Illness (CI) or Accidental Total and Permanent Disability (ATPD) or Death",
            id: "28",
            },
          ]
        } else {
          annuityOptionList = [
            {
            label:
                "Deferred Annuity with Return of Purchase Price on Death (Single Life)",
            id: "31",
            },
            {
            label:
                "Deferred Annuity with Return of Purchase Price on Critical Illness (CI) or Accidental Total and Permanent Disability (ATPD) or Death (Single Life)",
            id: "32",
            }
          ]
        }

      }else{
        form.$("secondary-annuitant-name").set("disabled",false)
        form.$("secondary-annuitant-date-of-birth").set("disabled",false);
        form.$("secondary-annuitant-gender").set("disabled",false);

        let requestData = props.data.bi_request
        let familyMemberType = props.data.family_member_type
        let journeyData = toJS(AuthStore.journeyData);

        let secondary_annuitant_name = requestData.SecondaryAnnuitantName?.toString() || '';
        let secondary_annuitant_date_of_birth = requestData.SecondaryAnnuitantDateofbirth || '';
        let secondary_annuitant_gender = requestData.SecondaryAnnuitantGender?.toString() || ''

        let genderList = {"Male":'8',"Female" :'9'}

        switch (familyMemberType) {
        
          case 'SELF':
              let spouseDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.SPOUSE)
  
                  if(spouseDetail) {
                       secondary_annuitant_name = spouseDetail.middle_name ? `${spouseDetail.first_name} ${spouseDetail.middle_name} ${spouseDetail.last_name}` : `${spouseDetail.first_name} ${spouseDetail.last_name}`
          
                       secondary_annuitant_date_of_birth = spouseDetail.dob 
          
                       secondary_annuitant_gender = genderList[spouseDetail.gender]
                  }
  
              break;
  
          case 'SPOUSE':
          let selfDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.SELF)
  
              if(selfDetail){
                  secondary_annuitant_name = selfDetail.middle_name ? `${selfDetail.first_name} ${selfDetail.middle_name} ${selfDetail.last_name}` : `${selfDetail.first_name} ${selfDetail.last_name}`
  
                  secondary_annuitant_date_of_birth = selfDetail.dob 
      
                  secondary_annuitant_gender = genderList[selfDetail.gender]
              }    
  
          break;
  
          case 'GRAND_FATHER':
              let grandMotherDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.GRAND_MOTHER)
      
                  if(grandMotherDetail){
                      secondary_annuitant_name = grandMotherDetail.middle_name ? `${grandMotherDetail.first_name} ${grandMotherDetail.middle_name} ${grandMotherDetail.last_name}` : `${grandMotherDetail.first_name} ${grandMotherDetail.last_name}`
      
                      secondary_annuitant_date_of_birth = grandMotherDetail.dob 
          
                      secondary_annuitant_gender = genderList[grandMotherDetail.gender]
                  }
  
              break;
  
          case 'GRAND_MOTHER':
              let grandFatherDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.GRAND_MOTHER)
      
                  if(grandFatherDetail){
                      secondary_annuitant_name = grandFatherDetail.middle_name ? `${grandFatherDetail.first_name} ${grandFatherDetail.middle_name} ${grandFatherDetail.last_name}` : `${grandFatherDetail.first_name} ${grandFatherDetail.last_name}`
      
                      secondary_annuitant_date_of_birth = grandFatherDetail.dob 
          
                      secondary_annuitant_gender = genderList[grandFatherDetail.gender]
                  }
  
              break;
      
          default:
              break;
      }

          // ! secondary-annuitant-name
          formRef.$('secondary-annuitant-name').set('value', secondary_annuitant_name)

          // ! secondary-annuitant-date-of-birth
          formRef.$('secondary-annuitant-date-of-birth').set('value', secondary_annuitant_date_of_birth)
          console.log('dobValue',moment(secondary_annuitant_date_of_birth).format('LL'));

          // ! secondary-annuitant-gender
          switch (secondary_annuitant_gender) {
          case '8':
              formRef.$('secondary-annuitant-gender').set('value', {label:"Male",id:'8'})
              break;
          case '9':
              formRef.$('secondary-annuitant-gender').set('value', {label:"Female",id:'9'})
              break;
          //  case '7':
          //   formRef.$('secondary-annuitant-gender').set('value', {label:"Transgender",id:'7'})
          //   break;    
          default:
              break;
          }

          Utils.updateBi(keys.NAME_OF_THE_SECONDARY_ANNUITANT,secondary_annuitant_name,props.data.product_id,formRef,props);

          Utils.updateBi(keys.GENDER_NAME_OF_THE_SECONDARY_ANNUITANT,secondary_annuitant_gender,props.data.product_id,formRef,props);

          const dateString = secondary_annuitant_date_of_birth ? moment(secondary_annuitant_date_of_birth).format('LL') : ""

          Utils.updateBi(keys.DOB_NAME_OF_THE_SECONDARY_ANNUITANT, dateString, props.data.product_id, formRef,props)


        // Immediate annuity
        if(Number(form.$("annuity-benefit").value.id) === 1) {
          annuityOptionList = [
            { label: "Life Annuity (Joint life, Last Survivor)", id: "29" },
            {
            label:
                "Life Annuity with Return of Purchase Price on Death (Joint life, Last Survivor)",
            id: "30",
            },
          ]
        } else {
          annuityOptionList = [
            {
              label:
                "Deferred Annuity with Return of Purchase Price on Death (Joint Life, Last Survivor)",
              id: "33",
            }
          ]
        }
      }
      formRef.$("annuity-option").set("extra", {
        ...formRef.$("annuity-option").extra,
        options: [...annuityOptionList],
      });

      formRef.$("annuity-option").set("value", annuityOptionList[0])
      let requestData = {
        annuityOption: annuityOptionList[0].id,
        lifeStatus: field.value.id
      }

      Utils.updateBi(
        keys.LIFE_STATUS,
        requestData,
        props.data.product_id,
        formRef,
        props
      );
    },
  })

  formRef.$("annuity-mode").observe({
    key: "value",
    call: ({ field }) => {
      Utils.updateBi(
        keys.ANNUITY_MODE,
        field.value.id,
        props.data.product_id,
        formRef,
        props
      );
    },
  })

  formRef.$("deferment-period").observe({
    key: "value",
    call: ({ field }) => {
      Utils.updateBi(
        keys.DEFERMENT_PERIOD,
        field.value.id,
        props.data.product_id,
        formRef,
        props
      );
    },
  })

  formRef.$("annuity-option").observe({
    key: "value",
    call: ({ field }) => {
      Utils.updateBi(
        keys.ANNUITY_OPTION,
        field.value.id,
        props.data.product_id,
        formRef,
        props
      );
    },
  })

  formRef.$("secondary-annuitant-gender").observe({
    key: "value",
    call: ({ field }) => {
      Utils.updateBi(
        keys.GENDER_NAME_OF_THE_SECONDARY_ANNUITANT,
        field.value.id,
        props.data.product_id,
        formRef,
        props
      );
    },
  })
}

export default FormObserver
